import { faA, faM, faU } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from '@mui/material'
const CategoryIcons = ({ Category }) => {
    return (
        Category === 'AUTHENTICATION' ?
            <Tooltip title={Category} placement="top"> 
                <FontAwesomeIcon icon={faA} size='30px' fontSize={20} className='CategoryIcons' />
            </Tooltip>
            : Category === 'MARKETING' ?
                <Tooltip title={Category} placement="top">
                    <FontAwesomeIcon icon={faM} size='30px' fontSize={20} className='CategoryIcons' />
                </Tooltip>
                : Category === 'UTILITY' ?
                    <Tooltip title={Category} placement="top">
                        <FontAwesomeIcon icon={faU} size='30px' fontSize={20} className='CategoryIcons' />
                    </Tooltip>
                    : null
    )
}

export default CategoryIcons